import DisqualifyingReasonsLoader, {
  type IDisqualifyingReasonsLoaderProps
} from "../Components/DisqualifyingReasonsLoader";
import useGetDisqualifyingReasons from "../hooks/useGetDisqualifyingReasons";
import AppContextValueProvider from "./AppContextValueProvider";

/** A {@link DisqualifyingReasonsLoader} which obtains its contact and disqualifying reasons context from the AppContext. */
const AppContextDisqualifyingReasonsLoader: React.FC = AppContextValueProvider<
  Omit<
    IDisqualifyingReasonsLoaderProps,
    "contactId" | "onChange" | "useGetDisqualifyingReasons" | "viewConnector" | "flow"
  >,
  IDisqualifyingReasonsLoaderProps
>({
  Component: DisqualifyingReasonsLoader,
  map: ({ contactId, setDisqualifyingReasonsCState, router, flowCState }) => ({
    contactId,
    onChange: setDisqualifyingReasonsCState,
    useGetDisqualifyingReasons: useGetDisqualifyingReasons,
    router,
    flow: flowCState
  })
}) as React.FC;

export default AppContextDisqualifyingReasonsLoader;
